import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const PASAdminAuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PASAdminAuthProvider = ({ children }) => {
  const [pasAdmin, setPasAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('pas_admin_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchAdmin();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchAdmin = async () => {
    try {
      const response = await axios.get(`${API}/pas-admin/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPasAdmin(response.data);
    } catch (err) {
      console.error('Failed to fetch PAS admin:', err);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/pas-admin/login`, { email, password });
    const { token: newToken, admin, master_wallet } = response.data;
    localStorage.setItem('pas_admin_token', newToken);
    setToken(newToken);
    setPasAdmin({ ...admin, master_wallet });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('pas_admin_token');
    setToken(null);
    setPasAdmin(null);
  };

  const refreshAdmin = async () => {
    if (token) {
      await fetchAdmin();
    }
  };

  return (
    <PASAdminAuthContext.Provider value={{
      pasAdmin,
      token,
      loading,
      login,
      logout,
      refreshAdmin,
      isAuthenticated: !!pasAdmin
    }}>
      {children}
    </PASAdminAuthContext.Provider>
  );
};

export const usePASAdminAuth = () => {
  const context = useContext(PASAdminAuthContext);
  if (!context) {
    throw new Error('usePASAdminAuth must be used within a PASAdminAuthProvider');
  }
  return context;
};
